import { useEffect, useRef } from 'react';

function PdpIcon({
  id,
  pdp_id,
  name,
  hoveredPdpId,
  setHoveredPdpId,
  tooltipSide = 'right',
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setHoveredPdpId(null);
      }
    };
    document.addEventListener('touchstart', handleOutside, { passive: true });
    return () => {
      document.removeEventListener('touchstart', handleOutside);
    };
  }, [setHoveredPdpId]);

  const toggleMobile = (e) => {
    e.stopPropagation();
    setHoveredPdpId((prev) => (prev === id ? null : id));
  };

  return (
    <div
      className="pdp-image-wrapper"
      ref={containerRef}
      onMouseEnter={() => setHoveredPdpId(id)}
      onMouseLeave={() => setHoveredPdpId(null)}
    >
      <img
        src={`${process.env.PUBLIC_URL}/pics/pdp/${pdp_id}_icon_FC.png`}
        alt={`PDP ${pdp_id}`}
        className="pdp-image"
        onTouchStart={toggleMobile}
      />
      {hoveredPdpId === id && (
        <div className={`tooltip info ${tooltipSide}`}>{name}</div>
      )}
    </div>
  );
}

export default PdpIcon;
